import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'
import FrontPageEnum from '../../enumerators/front-page.enum'

export default class SliderHomeComponent {
    constructor() {
        this.swipers = []

        this.strateTimeline()

        this.strateEvents()
    }

    strateTimeline() {
        if (
            $(FrontPageEnum.STRATE_TIMELINE).length > 0 &&
            !$(FrontPageEnum.STRATE_TIMELINE).is(':hidden')
        ) {
            const swiperKey = 'strate-timeline-swiper'

            const options = {
                mousewheel: {
                    forceToAxis: true,
                },
                slidesPerView: 1.33,
                spaceBetween: 16,
                keyboard: true,
                loop: false,
                passiveListeners: false,
                watchSlidesVisibility: true,
                breakpoints: {
                    600: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    999: {
                        slidesPerView: 3,
                        spaceBetween: 40,
                    },
                },
                navigation: {
                    nextEl: FrontPageEnum.STRATE_TIMELINE_NEXT,
                    prevEl: FrontPageEnum.STRATE_TIMELINE_PREV,
                },
                on: {
                    slideChange: function () {
                        if (this.isEnd) {
                            $(FrontPageEnum.STRATE_TIMELINE_PROGRESS_BAR).addClass(
                                'strate-timeline__items__progress-bar--end',
                            )
                        } else {
                            $(FrontPageEnum.STRATE_TIMELINE_PROGRESS_BAR).removeClass(
                                'strate-timeline__items__progress-bar--end',
                            )
                        }
                    },
                },
            }

            this.initSwiper(swiperKey, 'customer-card', options)
        }
    }

    strateEvents() {
        if (
            $(FrontPageEnum.STRATE_EVENTS).length > 0 &&
            !$(FrontPageEnum.STRATE_EVENTS).is(':hidden')
        ) {
            const swiperKey = 'strate-events-swiper'

            const options = {
                mousewheel: {
                    forceToAxis: true,
                },
                slidesPerView: 1.33,
                spaceBetween: 15,
                keyboard: true,
                loop: false,
                passiveListeners: false,
                watchSlidesVisibility: true,
                breakpoints: {
                    600: {
                        slidesPerView: 1.2,
                        spaceBetween: 20,
                    },
                    999: {
                        slidesPerView: 1,
                        spaceBetween: 37,
                    },
                },

                navigation: {
                    nextEl: FrontPageEnum.STRATE_EVENTS_NEXT,
                    prevEl: FrontPageEnum.STRATE_EVENTS_PREV,
                },
            }

            this.initSwiper(swiperKey, 'customer-card', options)
        }
    }

    async initSwiper(swiperKey, slideItemClass, options) {
        const slideItem = `[data-swiper="${swiperKey}"] > .${slideItemClass}`
        $(slideItem).wrapAll('<div class="swiper-wrapper"></div>').addClass('swiper-slide')
        this.swipers[swiperKey] = await Swiper.create(`[data-swiper="${swiperKey}"]`, options)
    }
}
